import React from 'react';
import { Form } from 'react-bootstrap';
import { ColorPalette, useTheme } from '../../preferences/ThemeContext';
import { useI18n } from '../../i18n/I18nContext';

const ThemePaletteControls = () => {
  const { palette, setPalette } = useTheme();
  const { t } = useI18n();

  return (
    <div className="theme-controls d-flex align-items-center">
      <Form.Select
        className="theme-select"
        aria-label="Color palette"
        size="sm"
        style={{ minWidth: 120, maxWidth: 140 }}
        value={palette}
        onChange={(event) => setPalette(event.target.value as ColorPalette)}
      >
        <option value="default">{t('common_default')}</option>
        <option value="ocean">{t('common_ocean')}</option>
        <option value="forest">{t('common_forest')}</option>
        <option value="sunset">{t('common_sunset')}</option>
      </Form.Select>
    </div>
  );
};

export default ThemePaletteControls;
